import { render, staticRenderFns } from "./MainPageContent.vue?vue&type=template&id=4f6e5b6a"
import script from "./MainPageContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainPageContent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports